<div class="login-screen">
    <div class="row w-100 m-0 align-login-card">
        <div class="offset-lg-1 col-xl-4 col-lg-6">
            <div class="card">
                <div class="card-body">
                    <img src="assets/images/logo.svg" class="m-auto d-table" />
                    <h2 class="mt-4 mb-3">Welcome to Collect X</h2>
                    <p>Sign in to your account to start.</p>

                    <form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="submitLoginForm()" novalidate>
                        <div class="row gy-3">
                            <!-- Email -->
                            <div class="col-lg-12">
                                <label class="text-start">Email Address <span class="text-danger">*</span></label>
                                <mat-form-field class="w-100">
                                    <input type="email" name="collectx_email"  matInput formControlName="UserEmail" (input)="trimInput($event)" maxlength="100" placeholder="Enter your email" />
                                </mat-form-field>
                                <mat-error *ngIf="submitted && loginFormControls['UserEmail'].errors?.['required']">
                                    {{ errorConstants.EmailRequired }}
                                </mat-error>
                                <mat-error *ngIf="submitted && loginFormControls['UserEmail'].errors?.['pattern']">
                                    {{ errorConstants.EmailNotValid }}
                                </mat-error>
                            </div>

                            <!-- Password -->
                            <div class="col-lg-12">
                                <label class="text-start">Password <span class="text-danger">*</span></label>
                                <mat-form-field class="w-100">
                                    <input matInput name="collectx_password"  [type]="isShowPassword ? 'text' : 'password'" formControlName="UserPassword" (input)="trimInput($event)" placeholder="Enter your password" />
                                    <span (click)="togglePasswordVisibility()">
                                        <img [src]="isShowPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'"
                                            class="iconset" />
                                    </span>
                                </mat-form-field>
                                <mat-error *ngIf="submitted && loginFormControls['UserPassword'].errors?.['required']">
                                    {{ errorConstants.PasswordRequired }}
                                </mat-error>
                            </div>

                            <!-- Remember Email + Forgot -->
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-between align-items-center flex-wrap">
                                    <mat-checkbox formControlName="keepMeLoggedIn">
                                        <span class="me-2">Remember my email</span>
                                    </mat-checkbox>
                                    <div class="col-lg-6 col-12">
                                        <div class="d-flex justify-content-end">
                                            <a href="javascript:void(0)" (click)="onForgotPassword()" class="text-danger">
                                                Forgot Password?
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12">
                                <app-recaptcha-widget #recaptchaWidget
                                    (resolved)="onCaptchaResolved()"
                                    (expired)="onCaptchaExpired()"></app-recaptcha-widget>
                            </div>
                            <div class="col-lg-12">
                                <button matButton="filled" type="submit" class="w-100 btn-primary"
                                    [disabled]="captchaService.isEnabled() && !isCaptchaVerified">
                                    Sign in
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="card-footer border-0 mt-5">
                        <p class="m-0">
                            © {{year}} ALL RIGHTS RESERVED.
                            <a href="https://www.vaultx.com/" class="fw-medium text-primary" target="_blank">
                                <span>Collect</span>&nbsp;<span class="text-dark">X</span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-7">
        </div>
    </div>
</div>